// App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import RouteOptimizationSystem from './RouteOptimizationSystem';
import CustomerTrackingPage from './CustomerTrackingPage';
import LoginPage from './LoginPage';
import UserList from './components/User/UserList';
import UserForm from './components/User/UserForm';
import RoleList from './components/Role/RoleList';
import RoleForm from './components/Role/RoleForm';
import { ConfigProvider } from './context/ConfigContext';

const isTokenValid = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

const PrivateRoute = ({ children }) => {
  return isTokenValid() ? children : <Navigate to="/" />;
};

const App = () => {
  return (
    <ConfigProvider>
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<LoginPage />} />

        {/* Private Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <RouteOptimizationSystem />
            </PrivateRoute>
          }
        />
        <Route path="/customer_tracking" element={<CustomerTrackingPage />} />

        {/* User Management Routes */}
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <UserList />
            </PrivateRoute>
          }
        />
        <Route
          path="/users/add"
          element={
            <PrivateRoute>
              <UserForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/users/edit/:id"
          element={
            <PrivateRoute>
              <UserForm />
            </PrivateRoute>
          }
        />

        {/* Role Management Routes */}
        <Route
          path="/roles"
          element={
            <PrivateRoute>
              <RoleList />
            </PrivateRoute>
          }
        />
        <Route
          path="/roles/add"
          element={
            <PrivateRoute>
              <RoleForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/roles/edit/:id"
          element={
            <PrivateRoute>
              <RoleForm />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
    </ConfigProvider>
  );
};

export default App;
